module.exports = "<ng-container *ngIf=\"this.router.url === '/'\">\r\n  <app-portfolio-layout></app-portfolio-layout>\r\n</ng-container>"